import dayjs from 'dayjs'

import { PortInDetails, PortInStatuses } from '@smarty-nx/data'
import { validatePacCode } from './validators'

export const isFailedPac = (details: PortInDetails | null): boolean =>
  details?.code_type === 'pac' &&
  details?.status === PortInStatuses.PORT_FAILURE

export const getPortInDate = (
  details: PortInDetails | null,
  nextWorkingDate: Date | null
): Date | null | undefined => {
  let date

  if (details) {
    const {
      requested_portin_date,
      code_type,
      expected_completion_date,
      status,
      completed_at,
    } = details
    const { PORT_SUCCESS, PORT_FAILURE } = PortInStatuses

    switch (true) {
      case status === PORT_SUCCESS && code_type === 'stac':
        date = dayjs(requested_portin_date).toDate()
        break
      case (status === PORT_SUCCESS || status === PORT_FAILURE) &&
        Boolean(completed_at): // STAC almost immediately has completed_at = created_at
        date = dayjs(completed_at).toDate()
        break
      case requested_portin_date &&
        dayjs(requested_portin_date).endOf('d') > dayjs():
        date = dayjs(requested_portin_date).toDate()
        break
      case code_type === 'pac':
        date = dayjs(expected_completion_date).toDate() || nextWorkingDate
        break
      default:
        date = expected_completion_date
          ? dayjs(expected_completion_date).toDate()
          : undefined
    }
  }

  return date
}

export const isPortInInfoVisible = (details: PortInDetails | null): boolean => {
  if (details) {
    const { PORT_SUCCESS, MAYBE_PORT_AFTER_ORDER, PORT_CANCELLED } =
      PortInStatuses
    const { status, code_type } = details

    return (
      (code_type === 'pac' &&
        status !== null &&
        ![PORT_SUCCESS, PORT_CANCELLED, MAYBE_PORT_AFTER_ORDER].includes(
          status as PortInStatuses
        )) ||
      /* for STAC we show first of all 'requested_date' when status, in fact, is already
      PORT_SUCCESS, so we hide component right after 'requested date'  */
      (code_type === 'stac' &&
        status === PortInStatuses.PORT_SUCCESS &&
        dayjs().diff(details.requested_portin_date, 'd') <= 0)
    )
  }

  return false
}

export function isCodeTypePac(code: string) {
  return /^[a-zA-Z]{3}\d{6}$/.test(code)
}

export function getCodeType(code: string) {
  return isCodeTypePac(code) ? 'pac' : 'stac'
}

// TODO: check if it's still actual or we need to fix it
export const getPortInOptionAndStatus = (
  isRequested: boolean,
  code: string | undefined = undefined,
  date: string | undefined = undefined
) => {
  const status = isRequested ? 'requested-port-in' : 'not-ported'

  let option
  if (isRequested && code) {
    const isPacCode = !validatePacCode(code)
    if (date) {
      option = isPacCode ? 'port-in-pac-with-date' : 'port-in-stac-with-date'
    } else {
      option = isPacCode ? 'port-in-pac-no-date' : 'port-in-stac-no-date'
    }
  } else {
    option = 'port-in-later'
  }

  return [option, status]
}

export const MAX_FAMILY_PLAN_POOL_NUMBERS = 10
